//Authenticate

export const apiGetChatBotInfo = `/aimanager/api/v2/GetChatBots`
export const apiChatBot = `/chatbot/QuestionAnswer/`
export const apiGetChatBotByID = `/aimanager/api/v2/GetChatBotByID`
